import React from 'react';
import { required, SimpleForm, TextInput, NumberInput } from 'react-admin';
import { nonNegativeInt } from 'utils/validation';

const HelpForm = (props) => {
  return (
    <SimpleForm {...props}>
      <NumberInput
        source="orderIndex"
        validate={[required(), nonNegativeInt]}
      />
      <TextInput source="question" validate={required()} multiline />
      <TextInput source="answer" validate={required()} multiline />
    </SimpleForm>
  );
};

export default HelpForm;
